import { render, staticRenderFns } from "./LanguageSwitcherContextMenu.vue?vue&type=template&id=99e1ce6a&"
import script from "./LanguageSwitcherContextMenu.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitcherContextMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e1ce6a')) {
      api.createRecord('99e1ce6a', component.options)
    } else {
      api.reload('99e1ce6a', component.options)
    }
    module.hot.accept("./LanguageSwitcherContextMenu.vue?vue&type=template&id=99e1ce6a&", function () {
      api.rerender('99e1ce6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LanguageSwitcherContextMenu.vue"
export default component.exports